<template>
  <div class="card-dash">
    <div class="ico ico__menu" @click="menu = !menu">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
          fill="#B3C2CB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5Z"
          fill="#B3C2CB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z"
          fill="#B3C2CB"
        />
      </svg>
    </div>
    <div class="overlay" v-if="menu" @click="menu = !menu"></div>
    <div class="menu" v-if="menu">
      <p
        :class="{ active: active == 'spotlight' }"
        @click="active = 'spotlight'"
      >
        Spotlight
      </p>
      <p :class="{ active: active == 'setting' }" @click="active = 'setting'">
        Setting
      </p>
      <p :class="{ active: active == 'splash' }" @click="active = 'splash'">
        Splash
      </p>
      <hr />
      <p class="danger">Remove</p>
    </div>

    <h2 class="title" v-if="active != 'splash'">
      {{ title }}
    </h2>

    <div class="settings" v-if="active == 'setting'">
      <div class="tabs__settings">
        <span
          @click="settings.active = 'settings'"
          :class="{ active: settings.active == 'settings' }"
        >
          Setting
        </span>
        <span
          @click="settings.active = 'set-up'"
          :class="{ active: settings.active == 'set-up' }"
        >
          Set-up
        </span>
        <span
          @click="settings.active = 'connect'"
          :class="{ active: settings.active == 'connect' }"
        >
          Connect
        </span>
      </div>
      <div class="body__settings">
        <template v-if="settings.active == 'settings'">
          <div
            v-for="(sett, ind) in setting"
            class="setting_"
            :key="ind"
            @click="sett.value = !sett.value"
          >
            <div class="toggler" :class="[sett.value ? 'bg' : '']">
              <div class="slider" :class="[sett.value ? 'btns' : '']"></div>
            </div>
            <span>
              {{ sett.text }}
            </span>
          </div>
          <h5 class="sign-in">
            Sign-In to Account
          </h5>
        </template>

        <div v-if="settings.active == 'set-up'">
          <slot name="setup">
            <h3 class="set-up">
              Nothing <br />
              To Set-Up
            </h3>
          </slot>
        </div>
        <div v-if="settings.active == 'connect'">
          <slot name="connect"></slot>
        </div>
      </div>
    </div>
    <div class="splash" v-if="active == 'splash'">
      <h5>{{ title }}</h5>
    </div>
    <slot name="spotlight" v-if="active == 'spotlight'"></slot>
  </div>
</template>

<script>
export default {
  props: ["title", "splash"],
  data() {
    return {
      menu: false,
      active: this.splash ? "splash" : "spotlight",
      settings: {
        active: "settings"
      },
      setting: [
        {
          text: "My Crew may access my set-up ",
          value: true
        },
        {
          text: "Display Stats on Splash",
          value: false
        }
      ]
    };
  },
  watch: {
    active() {
      this.menu = false;
    },
    splash() {
      this.active = this.splash ? "splash" : "spotlight";
    }
  }
};
</script>

<style lang="scss" scoped>
.card-dash {
  background: #ffffff;
  box-shadow: 6px 6px 20px rgba(20, 36, 74, 0.05);
  border-radius: 20px;
  padding: 16px;
  min-height: 300px;

  position: relative;
  .title {
    margin: 3px;
    text-align: center;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    text-transform: uppercase;
  }
  .ico__menu {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
  .menu {
    position: absolute;
    top: 26px;
    right: 34px;
    background-color: #fff;
    z-index: 3;
    box-shadow: 0px 6px 16px rgba(20, 36, 74, 0.08);
    border-radius: 5px;
    padding: 15px;
    width: 88px;
    padding-bottom: 5px !important;
    hr {
      margin: 10px 0;
      width: 88px;
      transform: translateX(-15px);
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 18px;
      color: #474d52;
      margin: 3px 0;
      padding: 3px 0;

      cursor: pointer;
      &.active {
        font-weight: bold;
      }
      &.danger {
        color: #ef5c4a;
      }
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2;
    background: transparent;
  }
}
.settings {
  .tabs__settings {
    margin-top: 16px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #ffffff;
    box-shadow: 6px 6px 20px rgba(20, 36, 74, 0.1);
    border-radius: 5px;
    height: 27px;
    span {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      color: #000000;
      cursor: pointer;
      &.active {
        font-weight: 800;
        font-size: 14px;
        line-height: 19px;
        color: #8d97e0;
      }
    }
  }
  .body__settings {
    padding: 10px;
    padding-top: 25px;
    .set-up {
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;
      color: #babcca;
    }
  }
}
.splash {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 264px;
  h5 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #babcca;
  }
}
.labels-radial {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.toggler {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  filter: drop-shadow(3.76471px 3.76471px 18.8235px rgba(22, 27, 69, 0.1));
  background: #fff;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  &.bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #557efb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
    &.btns {
      left: 50%;
      background: #557efb;
      box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
    }
  }
}

.setting_ {
  display: grid;
  grid-template-columns: 50px 1fr;
  margin-bottom: 14px;
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;

    color: #171e4e;
  }
}
.sign-in {
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 18px;
  color: #171e4e;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}
</style>
